import { unixTimestamp } from '@/utils'

/**
 * 将时间戳(秒级/毫秒级)转换为年月日 时分秒格式
 *  @param {number} t
 *  @return {string}
 */

export function formatTimestampFilter(t) {
  if (`${t}`.length === 10) {
    return unixTimestamp(t + '000')
  } else if (`${t}`.length === 13) {
    return unixTimestamp(t)
  } else {
    return '--'
  }
}

/**
 * 将秒转换为时分秒
 *  @param {number} t
 *  @return {string}
 */

export function formatSecondFilter(seconds) {
  let secondsN = Number(seconds)
  let h = Math.floor(secondsN / 3600)
  let m = Math.floor((secondsN / 60) % 60)
  let s = Math.floor(secondsN % 60)

  return `${h} 小时 ${m} 分钟 ${s} 秒`
}

/**
 * 过滤返回时间包含1970的字符串（相当于时间为空）
 *  @param {string} time
 *  @return {string}
 */

export function nullTimeFilter(time) {
  if (time.indexOf('1970') === -1) {
    return time
  } else {
    return '--'
  }
}
